import { useState, useEffect, useMemo } from "react";

import { AlertOctagon, Crown } from "lucide-react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Badge, Spinner } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import OlympicsLogo from "../../Conecta.png";

function SchoolOlympicsLeaderboard({ ...props }) {
  const olympicsId = props.match.params.id;

  const [leaderboardData, setLeaderboardData] = useState();
  const [errorMessage, setErrorMessage] = useState();
  const userSchoolId = props.user.user_roles[0].school_id;

  const currSchool = useMemo(
    () =>
      leaderboardData?.ranking.find(
        school => userSchoolId === school.school_id
      ),
    [leaderboardData]
  );

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (!leaderboardData) return;
      const newLeaderboard = {
        ...leaderboardData,
        end: getDateData(leaderboardData?.end?.date)
      };

      if (!newLeaderboard.color) newLeaderboard.color = "primary";

      setLeaderboardData(newLeaderboard);
    }, 1000);

    fetchLeaderboardData();

    return () => clearInterval(intervalId);
  }, []);

  const olympicsStatus = useMemo(() => {
    const currentDate = new Date();

    return currentDate >= new Date(leaderboardData?.olympic?.end)
      ? "Finalizada"
      : "Em progresso";
  }, [leaderboardData]);

  const fetchLeaderboardData = async () => {
    try {
      const leaderboardResponse = await axios.get(
        `${URL.api}olympics/rankingBySchool/${olympicsId}`,
        {
          headers: { Authorization: `Bearer ${props.user.token}` }
        }
      );

      const { data } = leaderboardResponse.data;
      setLeaderboardData(data);
    } catch (error) {
      toastr.error("Erro!", error.response.data.error);
      setErrorMessage(error.response.data.error);
    }
  };

  const getDateData = date => {
    const newDate = new Date(date);
    newDate.setHours(newDate.getHours() + 3);

    const simpleDate = [
      newDate.getFullYear(),
      newDate.getMonth() + 1,
      newDate.getDate()
    ]
      .reverse()
      .join("/");

    const daysLeft = Math.floor(
      (newDate.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)
    );
    const hoursLeft = Math.floor(
      (newDate.getTime() - new Date().getTime()) / (1000 * 60 * 60)
    );
    const minutesLeft = Math.floor(
      (newDate.getTime() - new Date().getTime()) / (1000 * 60)
    );

    return {
      date: newDate,
      simpleDate,
      daysLeft,
      hoursLeft: hoursLeft % 24,
      minutesLeft: minutesLeft % 60
    };
  };

  return (
    <div className="container">
      {leaderboardData ? (
        <>
          <section className="p-3 rounded-lg border d-flex flex-column mb-3">
            <div className="d-flex flex-column flex-md-row align-items-center h-100">
              <div
                className={`olympics-dashboard-logo d-flex align-items-center justify-content-center rounded p-2 w-100 mb-3 mb-md-0 mr-xl-3 bg-${leaderboardData.olympic.color}`}
              >
                <img
                  src={OlympicsLogo}
                  alt=""
                  style={{ objectFit: "cover", height: "180px" }}
                />
              </div>
              <div className="d-flex flex-column justify-content-between h-100 w-100">
                <div className="d-flex flex-column mb-4">
                  <div className="d-flex align-items-center mb-2">
                    <h3 className="mb-0 mr-2 font-weight-bold">
                      {leaderboardData.olympic.name}
                    </h3>
                    <Badge
                      color={leaderboardData.olympic.color}
                      className="text-white"
                    >
                      {olympicsStatus}
                    </Badge>
                  </div>

                  <small className="text-muted w-100">
                    {leaderboardData.olympic.description}
                  </small>

                  <div className="mt-5">
                    <p className="mb-0">
                      Sua escola ficou em{" "}
                      <strong className="text-orange">
                        {leaderboardData.ranking.findIndex(
                          school => userSchoolId === school.school_id
                        ) + 1}
                        º{" "}
                      </strong>
                      lugar com{" "}
                      <strong className="text-orange">
                        {currSchool.total_score}{" "}
                      </strong>
                      pontos.
                    </p>
                    <p className="mb-0">
                      {currSchool.school_id ===
                      leaderboardData?.ranking[0].school_id
                        ? "Procure o tutor da sua escola para informações da premiação!"
                        : "Não foi dessa vez, mas não se preocupe! No ano que vem tem mais."}
                    </p>
                  </div>
                </div>

                {/* <div className="d-flex align-items-center flex-1 mr-xl-2 mb-xl-0">
                  <label className="font-weight-semibold text-dark mr-3 mb-0">
                    Resultado final em:
                  </label>
                  <div className="d-flex align-items-center justify-content-center">
                    <div className="d-flex flex-column align-items-center justify-content-center">
                      <h5 className="font-weight-bold mb-0">
                        {getDateData(leaderboardData.olympic.end)?.daysLeft}
                      </h5>
                      <small className="text-dark">Dias</small>
                    </div>
                    <h4 className="mb-0 mx-3 text-muted">:</h4>
                    <div className="d-flex flex-column align-items-center justify-content-center">
                      <h5 className="font-weight-bold mb-0">
                        {getDateData(leaderboardData.olympic.end)?.hoursLeft}
                      </h5>
                      <small className="text-dark">Horas</small>
                    </div>
                    <h4 className="mb-0 mx-3 text-muted">:</h4>
                    <div className="d-flex flex-column align-items-center justify-content-center">
                      <h5 className="font-weight-bold mb-0">
                        {getDateData(leaderboardData.olympic.end)?.minutesLeft}
                      </h5>
                      <small className="text-dark">Minutos</small>
                    </div>
                  </div>
                </div> */}
              </div>

              <div
                className="flex-column d-flex align-items-center justify-content-center pt-5 w-100 h-100"
                style={{ maxWidth: "208px", aspectRatio: "1/1" }}
              >
                <div className="d-flex align-items-center mb-2">
                  <Crown size={24} className="text-yellow mr-2" />
                  <h5 className="m-0 font-weight-bold">1º lugar</h5>
                </div>
                <p className="mb-2 text-center">
                  {leaderboardData.ranking[0].name}
                </p>
                <Badge color="yellow" className="text-white mb-2">
                  {leaderboardData.ranking[0].total_score}pts
                </Badge>
                <div className="flex-1 w-100 bg-yellow-translucent rounded-top"></div>
              </div>
            </div>
          </section>

          <section className="p-3 border w-100 rounded-lg d-flex flex-column">
            <h4>
              <strong>Placar de escolas</strong>
            </h4>
            <div
              className="h-100 overflow-auto"
              style={{ maxHeight: "720px", minHeight: "300px" }}
            >
              {!leaderboardData.ranking ? (
                <div className="d-flex align-items-center justify-content-center w-100 h-100 rounded bg-light text-muted">
                  <Spinner color="secondary" size="sm" className="mr-1" />
                  Carregando escolas...
                </div>
              ) : (
                <ul className="d-flex flex-column list-unstyled p-0 m-0 h-100">
                  {leaderboardData.ranking.map((school, index) => (
                    <div
                      key={school.school_id}
                      className={`w-100 h-100 p-2 mb-2 rounded d-flex align-items-center text-decoration-none bg-${
                        index === 0
                          ? "yellow"
                          : index === 1
                          ? "slate"
                          : index === 2
                          ? "orange"
                          : currSchool.school_id === school.school_id
                          ? "purple"
                          : "secondary"
                      }-translucent`}
                      style={{ maxHeight: "72px" }}
                    >
                      <div
                        style={{ aspectRatio: "1/1", minWidth: "50px" }}
                        className={`p-2 h-100 mr-3 d-flex align-items-center rounded-sm justify-content-center bg-${
                          index === 0
                            ? "yellow"
                            : index === 1
                            ? "secondary"
                            : index === 2
                            ? "orange"
                            : currSchool.school_id === school.school_id
                            ? "purple"
                            : "transparent"
                        }`}
                      >
                        <h4
                          className={`m-0 text-${
                            index < 3 ||
                            currSchool.school_id === school.school_id
                              ? "white"
                              : "dark"
                          }`}
                        >
                          <strong>{index + 1}</strong>
                        </h4>
                      </div>
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <h5
                          className="font-weight-normal m-0 text-nowrap text-dark"
                          title={school.name}
                        >
                          {school.name}
                        </h5>

                        <h5
                          className="text-muted m-0 text-right"
                          title={school.discipline_name}
                          style={{ minWidth: "0" }}
                        >
                          <strong className="mr-1 text-dark">
                            {school.total_score}
                          </strong>
                          pontos
                        </h5>
                      </div>
                    </div>
                  ))}
                </ul>
              )}
            </div>
          </section>
        </>
      ) : errorMessage ? (
        <div className="d-flex align-items-center justify-content-center w-100 h-100 pt-5">
          <AlertOctagon size={56} className="text-danger mr-2" />
          <div className="d-flex flex-column">
            <h3 className="mb-0 font-weight-bold text-danger">Atenção!</h3>
            <p className="mb-0 text-muted">{errorMessage}</p>
          </div>
        </div>
      ) : (
        <div className="d-flex align-items-center justify-content-center w-100 h-100 pt-5">
          <Spinner color="secondary" size="sm" className="mr-2" />
          Carregando dados da olimpíada...
        </div>
      )}
      <ProtectedRoute routeId={props.currentRoute} />
    </div>
  );
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SchoolOlympicsLeaderboard);
